export default __webpack_public_path__ + "static/media/alessandro7.76cee570.jpg";